export let BlobKey;

(function (BlobKey) {
  BlobKey[BlobKey["ImageBlob"] = 0] = "ImageBlob";
  BlobKey[BlobKey["GridBlob"] = 1] = "GridBlob";
  BlobKey[BlobKey["IllustrationBlob"] = 2] = "IllustrationBlob";
  BlobKey[BlobKey["AnimationBlob"] = 3] = "AnimationBlob";
})(BlobKey || (BlobKey = {}));